export const events = {
  clickGlpButton: 'Click GLP button',
  seeLandingPage: 'See landing page',
}
